import ArticleForm from "components/organisms/ArticleForm";
import { useScrollToTop } from "hooks";
import type { ReactNode } from "react";

function NewArticlePage(): ReactNode {
  useScrollToTop();
  return <ArticleForm creation />;
}

export default NewArticlePage;
